// prettier-ignore
export function getPatchDataObject(config, filtersState, firstSelectIdEntitiesList, secondSelectIdEntitiesList) {
	const firstFormControlName = config.firstSelect.formControlName;
	const secondFormControlName = config.secondSelect.formControlName;

	return {
		[firstFormControlName]: filtersState[firstFormControlName] ? filtersState[firstFormControlName] : firstSelectIdEntitiesList,
		[secondFormControlName]: filtersState[secondFormControlName] ? filtersState[secondFormControlName] : secondSelectIdEntitiesList,
		search: filtersState.search ? filtersState.search : null,
	};
}

// prettier-ignore
export function getResetDataObject(config, firstSelectIdEntitiesList, secondSelectIdEntitiesList) {
	const firstFormControlName = config.firstSelect.formControlName;
	const secondFormControlName = config.secondSelect.formControlName;

	return {
		[firstFormControlName]: firstSelectIdEntitiesList,
		[secondFormControlName]: secondSelectIdEntitiesList,
		search: null,
	};
}
